<template>
  <div class="container-dash margin-top ">
    <a-form :form="form">
      <a-form-item label="Report Date">
        <a-date-picker
          placeholder="Select Date"
          :format="getDefaultDateFormat"
          :disabled="collectData.usage.length>0"
          v-decorator="[
            'report_date',
            {
              rules: [{ required: true }],
              initialValue: initialData.report_date,
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="End User CC">
        <a-select
          :disabled="collectData.usage.length>0"
          showSearch
          placeholder="Select No. UM"
          v-decorator="[
            'id_user_cc',
            { rules: [{ required: true }], initialValue: initialData.id_user_cc },
          ]"
        >
          <a-select-option v-for="item in baseData.kartu_kredit" :key="item.id_user_cc">
            {{ item.type_cc}} | {{ item.tlc_user }} [{{ item.no_cc }} / {{formatCurrency('IDR', item.limit_kredit)}}]
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "informasiTravelokaKlaim",
  props: {
    mode: String,
    baseData: {},
    collectData: []
  },
  mixins: [GlobalMethod, CurrencyFormat],
  data() {
    return {
      pageLoading: true,
      assignee:[],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getLapListUM",
    ]),
    initialData() {
      if (this.collectData.information.length == 0) {
        return {
          report_date: null,
          id_user_cc: "",
        };
      } else {
        return {
          report_date: this.collectData.information.report_date,
          id_user_cc: this.collectData.information.id_user_cc,
        };
      }
    },
  },
  mounted(){
  },
  methods: {
    moment,
    handleRef(){
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        const informasi = {
          report_date: values.report_date,
          id_user_cc: values.id_user_cc
        };

        Event.$emit("collectTraveloka", informasi);
      })
    },
  }
}
</script>